import { stack, stackOffsetDiverging } from 'd3-shape';
import { min, max } from 'd3-array';
import { linearAxis, bandAxis } from '../../../factory/axes';
import { ordinalScale } from '../../../factory/scales';

import data from './data/data.json';
import { teal, census } from './utils/colors';

export default function (props) {
  const { initialWidth } = props;
  const keys = Object.keys(data[0]).slice(1);

  const series = stack()
    .offset(stackOffsetDiverging)
    .keys(keys)(data);

  const maxValue = max(series, serie => max(serie, d => d[1]));
  const minValue = min(series, serie => min(serie, d => d[0]));

  const margins = {
    top: 0,
    right: 20,
    bottom: 20,
    left: 50,
  };

  const barHeight = 90;
  const padding = 0.4;

  const width = initialWidth - margins.right - margins.left;
  const height = data.length * (barHeight + (barHeight * padding));

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, width],
    domain: [Math.min(0, minValue), maxValue],
    nice: false,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [0, height],
    domain: data.map(d => d.label),
    padding,
  };

  const { axis: xAxis, scale: x } = linearAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = bandAxis(yAxisConfig);

  const colorScale = ordinalScale({
    range: census[keys.length - 1],
    domain: keys,
  });

  return {
    colorScale,
    data: series,
    height,
    initialWidth,
    initialHeight: height + margins.top + margins.bottom,
    margins,
    width,
    x,
    xAxis,
    y,
    yAxis,
  };
}
